import { lazy } from "react";
import Loadable from "../components/Loadable";
import { authRoles } from "../auth/authRoles";

const LandingPage = Loadable(lazy(() => import("../views/pages/landingPage")));
const PublicEventThroughUrl = Loadable(lazy(() => import("../views/events/eventDetails/publicEventThroughUrl")));
const ContactSupport = Loadable(lazy(() => import("../views/footer/contactSupport/index")));

const publicRoutes = [
  { path: "/login?", element: <LandingPage/> },
  { path: "/:id", element: <PublicEventThroughUrl /> },
  { path: "/contact-support", element: <ContactSupport />, auth: authRoles.admin },
];

export default publicRoutes;